import { useNavigate } from "react-router-dom";
import { Heading } from "../../../components/Theme/heading";
import { getUrlHash } from "../../../components/navigation/URL";
import { OneCardPage } from "../../../components/utils/OneCardPage";
import { useCreateWirelessSurvey } from "../../../hooks/createEntity";
import { companyObjectPageTitle } from "../../../hooks/setPageTitle";
import { useSelectedCompany } from "../../../hooks/useCompany";
import { useSelectedScheme } from "../../../hooks/useScheme";
import { usePrivacyMode } from "../../../reducers/privacy";
import WirelessSurveyCreateForm from "./WirelessSurveyCreateForm";

function WirelessSurveyCreatePage() {
  const createEntity = useCreateWirelessSurvey();

  const navigate = useNavigate();
  // The selected company/scheme is read from the URL hash (see useSelectedCompanyId),
  // so the post-create navigation must carry it forward. Omitting the hash deselects the
  // company ("cut out of the company"); CompanyNavLink retains it the same way.
  const company = useSelectedCompany();
  const scheme = useSelectedScheme();
  const privacyMode = usePrivacyMode();

  return (
    <OneCardPage
      headerTitle={"Create Wireless Survey"}
      breadcrumbs={[
        {
          url: "/admin/wireless_survey",
          name: "Wireless Surveys",
        },
        {
          url: "/admin/wireless_survey/create",
          name: "Create",
        },
      ]}
      setPageTitle={companyObjectPageTitle("Create Wireless Survey")}
    >
      <Heading>Create New Wireless Survey</Heading>
      <WirelessSurveyCreateForm
        createWirelessSurvey={createEntity}
        onCreate={(surveyId) =>
          navigate({
            pathname: `/admin/asset_register/wireless_survey/view/${surveyId}`,
            hash: getUrlHash(company, scheme, privacyMode),
          })
        }
      />
    </OneCardPage>
  );
}

export default WirelessSurveyCreatePage;
